import { Component, input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProfileTypeString } from '../../../profile/store/profile.entity';
import { BrandingService } from "../../../branding/providers/branding.service";
import { BrandingState } from "../../../branding/store/branding.state";
import { AsyncPipe } from '@angular/common';
import { ToggleSideBarComponent } from '../toggle-side-bar/toggle-side-bar.component';
import { DoctorQuestionsComponent } from '../doctor-questions/doctor-questions.component';
import { PatientsQuestionsComponent } from '../patients-questions/patients-questions.component';
import { BrandedHeaderComponent } from '../../../header/components/branded-header/branded-header.component';
import { FooterComponent } from '../../../footer/footer.component';

@Component({
    selector: 'app-login-layout',
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.scss'],
    imports: [ToggleSideBarComponent, DoctorQuestionsComponent, PatientsQuestionsComponent, BrandedHeaderComponent, FooterComponent, AsyncPipe]
})
export class LoginLayoutComponent implements OnInit {
    readonly questions = input<ProfileTypeString>(undefined);
    public brandingSettings$: Observable<BrandingState>;
    public helpControl$ = new BehaviorSubject(false);

    constructor(private brandingService: BrandingService) {
    }

    ngOnInit(): void {
        this.brandingSettings$ = this.brandingService.getBrandingSettingsFromStore();
    }
}
